import { Popover } from '@mui/material';
import React from 'react';

import { Button } from '@/components/Button';

import s from './DragSelectionPopover.module.scss';

type DragSelectionPopoverProps = {
  open: boolean;
  anchorPosition: { top: number; left: number } | null;
  onLogTime: () => void;
  onCreateDraft: () => void;
  onClose: () => void;
  /** Показывать кнопку «Создать черновик» (только при просмотре своего пользователя) */
  showCreateDraftOption?: boolean;
};

const DragSelectionPopover: React.FC<DragSelectionPopoverProps> = ({
  open,
  anchorPosition,
  onLogTime,
  onCreateDraft,
  onClose,
  showCreateDraftOption = true,
}) => {
  if (!anchorPosition) return null;

  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={onClose}
      slotProps={{
        paper: {
          className: s.drag_selection_popover,
        },
      }}
    >
      <Button variant="contained" size="small" onClick={onLogTime}>
        Залогировать время
      </Button>
      {showCreateDraftOption && (
        <Button variant="outlined" size="small" onClick={onCreateDraft}>
          Создать черновик
        </Button>
      )}
    </Popover>
  );
};

export { DragSelectionPopover };
